import { Box, Typography } from "@mui/material";
import {
  WarningAmberRounded as WarningIcon,
  ChevronRight as ArrowIcon,
} from "@mui/icons-material";

const AlertBanner = ({ count, label, description, onClick }) => {
  if (!count) return null;

  return (
    <Box
      onClick={onClick}
      role="button"
      tabIndex={0}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        backgroundColor: "#FFF7ED",
        border: "1px solid #F4B860",
        borderRadius: 3,
        px: { xs: 1.5, sm: 2 },
        py: 1.25,
        mb: 2,
        cursor: onClick ? "pointer" : "default",
        "&:hover": onClick
          ? { backgroundColor: "#FFF1DE", borderColor: "#E8A23C" }
          : {},
        transition: "all 0.15s ease",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 32,
          height: 32,
          borderRadius: "50%",
          backgroundColor: "#FDE8C8",
          flexShrink: 0,
        }}
      >
        <WarningIcon sx={{ fontSize: 18, color: "#B8791A" }} />
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: 13.5, fontWeight: 700, color: "#8A5A17" }}>
          {count} {label}
        </Typography>
        {description && (
          <Typography sx={{ fontSize: 12, color: "#A47A3A", mt: 0.15 }}>
            {description}
          </Typography>
        )}
      </Box>

      {onClick && (
        <ArrowIcon sx={{ fontSize: 20, color: "#B8791A", flexShrink: 0 }} />
      )}
    </Box>
  );
};

export default AlertBanner;
